<!--
  SPDX-License-Identifier: MPL-2.0

  Svelte port of ImageLightbox.tsx. Modal-style image viewer with
  Escape-to-close and body scroll lock. Not yet mounted at runtime —
  ImageLightbox.tsx remains the live component until M5 mount swap.
-->

<script lang="ts">
  import { currentLocale, t } from '../../../infra/i18n'
  import { svelteSignal } from '../../svelteSignal.svelte'
  import { escapeKey, scrollLock, outsideClick } from '../../modalActions'

  type Props = { url: string; name: string; onClose: () => void }
  let { url, name, onClose }: Props = $props()

  const localeR = svelteSignal(currentLocale)
  const L = $derived((localeR.value, {
    viewer: t('image.viewer'),
    closeViewer: t('image.close_viewer'),
  }))
</script>

<div
  class="lightbox-overlay"
  role="dialog"
  aria-modal="true"
  aria-label={L.viewer}
  use:scrollLock
>
  <div
    class="lightbox-content"
    role="presentation"
    use:escapeKey={onClose}
    use:outsideClick={onClose}
  >
    <button class="lightbox-close" type="button" aria-label={L.closeViewer} onclick={() => onClose()}>×</button>
    <img class="lightbox-image" src={url} alt={name} onclick={() => onClose()} role="img" />
  </div>
</div>
